module.exports = __webpack_public_path__ + "static/img/grab_active.d242d86f.png";